import * as Yup from "yup";
import { TStep } from "../types";
import { GuidedDetailsStep } from "../steps/guided";
import { Concerns, Outcomes, states } from "./questionOptions";
export const guidedSteps: {
  [key: string]: TStep;
} = {
  "guided-step-two": {
    type: "form",
    title: "How would you describe your main concern?",
    note: "Select what most closely matches your concern or select ‘other’ if you don’t see anything that fits.",
    components: [
      {
        type: "radio",
        name: "concern",
        options: Concerns,
        validation: Yup.string().required("Please select at least 1"),
      },
    ],
    previous: "/legal-resources",
    next: "guided-step-three",
    submit: false,
    stepText: "Step 2 of 3",
    stepNumber: "2",
  },
  "guided-step-three": {
    type: "form",
    title: "What outcome would you like to achieve?",
    note: "Select as many as are relevant.",
    components: [
      {
        type: "checkbox",
        name: "outcomes",
        options: Outcomes,
        validation: Yup.array(),
      },
    ],
    previous: "guided-step-two",
    next: "/legal-resources-results",
    submit: false,
    stepText: "Step 3 of 3",
    stepNumber: "3",
  },
  "guided-details": {
    type: "content",
    component: <GuidedDetailsStep />,
    stepNumber: "5",
  },
  "edit-guided-location": {
    type: "form",
    title: "Edit location",
    components: [
      {
        type: "radio",
        name: "location",
        options: states,
        validation: Yup.string().required("Please select at least 1"),
      },
    ],
    customButtonText: "Apply",
    next: "/legal-resources-results",
    submit: false,
    stepNumber: "1.5",
  },
  "edit-guided-concerns": {
    type: "form",
    title: "Edit concerns",
    note: "Select what most closely matches your concern or select ‘other’ if you don’t see anything that fits.",
    components: [
      {
        type: "radio",
        name: "concern",
        options: Concerns,
        validation: Yup.string().required("Please select at least 1"),
      },
    ],
    customButtonText: "Apply",
    next: "/legal-resources-results",
    submit: false,
    stepNumber: "2.5",
  },
  "edit-guided-outcomes": {
    type: "form",
    title: "Edit outcomes",
    note: "Select as many as are relevant.",
    components: [
      {
        type: "checkbox",
        name: "outcomes",
        options: Outcomes,
        validation: Yup.array(),
      },
    ],
    customButtonText: "Apply",
    next: "/legal-resources-results",
    submit: false,
    stepNumber: "3.5",
  },
};
